import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/layout/AppShell";
import { RouteGuard } from "@/components/layout/RouteGuard";
import AICatalogPage from "@/pages/AICatalog/index";

const AICatalogRoute = () => {
  const { t } = useTranslation();

  return (
    <RouteGuard>
      <AppShell title={t("aiCatalog.title")} contentWidth="contained">
        <AICatalogPage />
      </AppShell>
    </RouteGuard>
  );
};

export const Route = createFileRoute("/ai-catalog")({
  component: AICatalogRoute,
});
